import { EquipmentsResponse } from "../../hooks/react-query/outbound/freightDetails/useGetEquipments";

export const equipmentList = {
  default: {
    available: [
      {
        equipmentId: 23878,
        trailerNumber: "ONTGHOST13",
        doorNumber: null,
        status: "EMTY",
        inUseInfo: null,
        loadSummary: { bills: 0, pallets: 0, pieces: 0, weight: 0 },
      },
      {
        equipmentId: 23894,
        trailerNumber: "DYLT242201",
        doorNumber: null,
        status: "EMTY",
        inUseInfo: null,
        loadSummary: { bills: 0, pallets: 0, pieces: 0, weight: 0 },
      },
    ],
    assigned: [
      {
        equipmentId: 23935,
        trailerNumber: "DYLT195042",
        doorNumber: null,
        status: "ENRT",
        inUseInfo: { id: 1, name: "1020304050", status: "LDDK", type: "Trip" },
        loadSummary: { bills: 10, pallets: 5, pieces: 3, weight: 1200 },
      },
      {
        equipmentId: 23961,
        trailerNumber: "DYLT205016",
        doorNumber: null,
        status: "CLOS",
        inUseInfo: { id: 2, name: "TRAP NAME 1", status: "TRAP", type: "Trap" },
        loadSummary: { bills: 10, pallets: 5, pieces: 3, weight: 1200 },
      },
    ],
    loadAndHold: [
      {
        tripNumber: 869430,
        equipmentId: 1,
        trailerNumber: "ABC-123",
        status: "CLOS",
        sic: "ONT",
        carrier: "ORANGE TRANSPORTATION LLC",
        gateTime: "10:30 AM",
        inUseInfo: { id: 1, name: "102030", status: "LDDK", type: "Trip" },
        loadSummary: { bills: 10, pallets: 5, pieces: 3, weight: 1200 },
      },
      {
        tripNumber: 746589,
        equipmentId: 3,
        trailerNumber: "ZWE-123",
        status: "CLOS",
        sic: "",
        carrier: "ORANGE TRANSPORTATION LLC",
        gateTime: "10:30 AM",
        inUseInfo: { id: 1, name: "102030", status: "LDDK", type: "Trip" },
        loadSummary: { bills: 10, pallets: 5, pieces: 3, weight: 1200 },
      },
    ],
  },
} as const satisfies Record<string, EquipmentsResponse>;
